@if (currentUser) {
  <div class="row">
    <div class="col-12 form-group">
      <label>{{ "Template.SettingsComponent.label_name" | translate }}</label>
      <div class="row">
        <div class="col-10">
          <div class="row">
            <app-name-form-legacy class="col-10" [firstName]="currentUser.firstname" [lastName]="currentUser.lastname" [username]="currentUser.username" [mode]="showNameForm ? FORM_COMP_MODES.EDIT : FORM_COMP_MODES.DISPLAY" (exitFormEvent)="exitNameForm($event)"></app-name-form-legacy>
          </div>
        </div>
        <div class="col-2">
          <button class="btn btn-secondary .editButton" (click)="toggleNameForm()" type="button" placement="top"
            ngbTooltip="{{ 'Template.SettingsComponent.text_edit' | translate }}">
            <fa-icon icon="pencil-alt"></fa-icon>
          </button>
        </div>
      </div>
      @if (nameError) {
        <div class="alert alert-danger text-center mt-2">
          {{nameError}}
        </div>
      }
    </div>
    <hr />
  </div>
}

<div class="row">
  @if (currentUser) {
    <div class="form-group">
      @if (!changeRequested) {
        <label>{{ 'Template.SettingsComponent.label_emailAdress' | translate }}</label>
      }
      @if (changeRequested) {
        <label>{{ 'Template.SettingsComponent.label_emailAdressChangeRequested' | translate }}</label>
      }
      <div class="row mt-2">
        <div class="col-10">
          <app-email-form-legacy class="col-10" [email]="currentUser.email" [mode]="showEmailForm ? FORM_COMP_MODES.EDIT : FORM_COMP_MODES.DISPLAY" [username]="currentUser.username" (exitFormEvent)="exitEmailForm($event)"></app-email-form-legacy>
        </div>
        <div class="col-2">
          <button class="btn btn-secondary .editButton" (click)="toggleEmailForm()" type="button" placement="top"
            ngbTooltip="{{ 'Template.SettingsComponent.text_edit' | translate }}">
            <fa-icon icon="pencil-alt"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  }
  <hr />
</div>

<div class="row">
  @if (currentUser) {
    <div class="form-group">
      <label>{{ 'Template.SettingsComponent.label_password' | translate }}</label>
      <div class="row mt-2">
        <div class="col-10">
          @if (showPasswordForm) {
            <app-password-change-form class="col-10" [username]="currentUser.username" [mode]="FORM_COMP_MODES.EDIT" (exitFormEvent)="exitPasswordForm($event)"></app-password-change-form>
          }
          @if (!showPasswordForm) {
            <input type="password" readonly value="***********" class="form-control-plaintext" />
          }
        </div>
        <div class="col-2">
          <button class="btn btn-secondary .editButton" (click)="togglePasswordForm()" type="button" placement="top"
            ngbTooltip="{{ 'Template.SettingsComponent.text_edit' | translate }}">
            <fa-icon icon="pencil-alt"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  }
</div>